import { COLUMN_ACCESS, COLUMN_BUILDING, COLUMN_CATEGORY, COLUMN_COMPANY, COLUMN_CONTROLLER, COLUMN_DATE, COLUMN_DATE_TIME, COLUMN_DEPARTMENT, COLUMN_DEVICE, COLUMN_DIRECTION, COLUMN_DISPLAY_NAME, COLUMN_DOOR, COLUMN_EVENT, COLUMN_FIRST_NAME, COLUMN_FIXED_ADDRESS, COLUMN_FLOOR, COLUMN_GENDER, COLUMN_LAST_NAME, COLUMN_LOGICAL_ADDRESS, COLUMN_OSS_DEVICE_NAME, COLUMN_READER, COLUMN_REASON_CODE, COLUMN_SECOND_NAME, COLUMN_SERIAL_ADDRESS, COLUMN_SITE, COLUMN_TAG_CODE, COLUMN_TITLE, COLUMN_TRANSACK_TYPE, COLUMN_ZONE } from "../../constants/column-types";
import { FILTER_BUILDINGS, FILTER_COMPANIES, FILTER_CONTROLLER, FILTER_DATE, FILTER_DEPARTMENTS, FILTER_DOORS, FILTER_EVENTS, FILTER_OSS_DEVICE, FILTER_READERS, FILTER_SITES, FILTER_TAGHOLDERS, FILTER_ZONES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const TransactionColumn: TableColumn[] = [
    {
        heading: "Date/Time",
        accessor: "dateTime",
        isNumeric: false,
        id: 0,
        sortByName: "trDatetimelocal",
        sortDirection: "asc",
        active: true,
        translationKey: "dateTime",
        columnId: COLUMN_DATE_TIME,
    },
    {
        heading: "Display Name",
        accessor: "name",
        isNumeric: false,
        id: 1,
        sortByName: "trMasterMstDisplayname",
        sortDirection: "asc",
        lookupName: "masterByTrMasterId.mstDisplayname",
        searchOnName: "masterByTrMasterId.id",
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME,
        filterId: FILTER_TAGHOLDERS,
        settingDataName: 'master'
    },
    {
        heading: "Event",
        accessor: "eventType",
        isNumeric: false,
        id: 2,
        sortByName: "eventType.trnName",
        sortDirection: "asc",
        active: true,
        lookupName: "eventType.nameOriginal",
        searchOnName: "eventType.id",
        translationKey: "event",
        columnId: COLUMN_EVENT,
        filterId: FILTER_EVENTS,
        settingDataName: 'eventType'
    },
    {
        heading: "Master Controller",
        accessor: "masterController",
        isNumeric: false,
        id: 3,
        sortByName: "trCtrlName",
        lookupName: "controller.devName",
        searchOnName: "controller.id",
        sortDirection: "asc",
        active: true,
        translationKey: "masterController",
        columnId: COLUMN_CONTROLLER,
        filterId: FILTER_CONTROLLER,
        settingDataName: 'deviceImprox'
    },
    {
        heading: "Reader",
        accessor: "reader",
        isNumeric: false,
        id: 4,
        sortByName: "trDevName",
        lookupName: "terminal.devName",
        searchOnName: "terminal.id",
        sortDirection: "asc",
        active: true,
        translationKey: "reader",
        columnId: COLUMN_READER,
        filterId: FILTER_READERS,
        settingDataName: 'deviceImprox'
    },
    {
        heading: "OSS Device",
        accessor: "ossDevice",
        isNumeric: false,
        id: 5,
        sortByName: "trOssdName",
        lookupName: "ossDevice.trOssdName",
        searchOnName: "ossDevice.id",
        sortDirection: "asc",
        active: true,
        translationKey: "ossDevice",
        columnId: COLUMN_OSS_DEVICE_NAME,
        filterId: FILTER_OSS_DEVICE,
        // settingDataName: 'ossDevice' // Still needs database support, so you can't save this filter preference yet.
    },
    {
        heading: "Transaction Type",
        accessor: "transactionType",
        isNumeric: false,
        id: 6,
        sortByName: "transackType.trnName",
        active: true,
        translationKey: "transactionType",
        columnId: COLUMN_TRANSACK_TYPE,
    },
    {
        heading: "Building",
        accessor: "building",
        isNumeric: false,
        id: 7,
        sortByName: "trBuildingName",
        searchOnName: "building.id",
        lookupName: "building.buildingName",
        sortDirection: "asc",
        active: false,
        translationKey: "building",
        columnId: COLUMN_BUILDING,
        filterId: FILTER_BUILDINGS,
        settingDataName: 'building'
    },
    {
        heading: "Floor",
        accessor: "floor",
        isNumeric: false,
        id: 8,
        sortByName: "trFloorName",
        sortDirection: "asc",
        active: false,
        translationKey: "floor",
        columnId: COLUMN_FLOOR,
        settingDataName: 'floors'
    },
    {
        heading: "Zone",
        accessor: "zone",
        isNumeric: false,
        id: 9,
        sortByName: "trZoneName",
        lookupName: "zone.zoneName",
        searchOnName: "zone.id",
        sortDirection: "asc",
        active: false,
        translationKey: "zone",
        columnId: COLUMN_ZONE,
        filterId: FILTER_ZONES,
        settingDataName: 'zone'
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 10,
        sortByName: "trSiteName",
        lookupName: "site.siteName",
        searchOnName: "site.id",
        sortDirection: "asc",
        active: false,
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site'
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        isNumeric: false,
        id: 11,
        sortByName: "trTagcode",
        sortDirection: "asc",
        active: false,
        translationKey: "cardNumber",
        columnId: COLUMN_TAG_CODE,
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        isNumeric: false,
        id: 12,
        sortByName: "trDevFixedaddr",
        sortDirection: "asc",
        active: false,
        translationKey: "fixedAddress",
        columnId: COLUMN_FIXED_ADDRESS,
    },
    {
        heading: "Logical Address",
        accessor: "logicalAddress",
        isNumeric: false,
        id: 13,
        sortByName: "trSla",
        sortDirection: "asc",
        active: false,
        translationKey: "logicalAddress",
        columnId: COLUMN_LOGICAL_ADDRESS,
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 14,
        sortByName: "trCompName",
        lookupName: "company.compName",
        searchOnName: "company.id",
        sortDirection: "asc",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: 'company'
    },
    {
        heading: "Serial Address",
        accessor: "serialAddress",
        isNumeric: false,
        id: 15,
        sortByName: "trDevSerial",
        sortDirection: "asc",
        active: false,
        translationKey: "serialAddress",
        columnId: COLUMN_SERIAL_ADDRESS,
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 16,
        sortByName: "trDeptName",
        lookupName: "department.deptName",
        searchOnName: "department.id",
        sortDirection: "asc",
        active: false,
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: 'department'
    },
    {
        heading: "Door",
        accessor: "door",
        isNumeric: false,
        id: 17,
        sortByName: "trLocName",
        lookupName: "location.locName",
        searchOnName: "location.id",
        sortDirection: "asc",
        active: false,
        translationKey: "door",
        columnId: COLUMN_DOOR,
        filterId: FILTER_DOORS,
        settingDataName: 'location'
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 18,
        sortByName: "masterByTrMasterId.mstFirstname",
        sortDirection: "asc",
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME,
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 19,
        sortByName: "masterByTrMasterId.mstMiddlename",
        sortDirection: "asc",
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME,
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 20,
        sortByName: "masterByTrMasterId.mstLastname",
        sortDirection: "asc",
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME,
    },
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 21,
        sortByName: "masterByTrMasterId.mstTitle",
        sortDirection: "asc",
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE,
    },
    {
        heading: "Gender",
        accessor: "gender",
        isNumeric: false,
        id: 22,
        sortByName: "masterByTrMasterId.mstGender",
        sortDirection: "asc",
        active: false,
        translationKey: "gender",
        columnId: COLUMN_GENDER,
    },
    {
        heading: "Category",
        accessor: "category",
        isNumeric: false,
        id: 23,
        sortByName: "masterByTrMasterId.profile.trnName",
        sortDirection: "asc",
        active: false,
        translationKey: "category",
        columnId: COLUMN_CATEGORY,
    },
    {
        heading: "Reason Code",
        accessor: "reasonCode",
        isNumeric: true,
        id: 24,
        sortByName: "trReasoncode",
        sortDirection: "asc",
        active: false,
        translationKey: "reasonCode",
        columnId: COLUMN_REASON_CODE,
    },
    {
        heading: "Device Type",
        accessor: "deviceType",
        isNumeric: false,
        id: 25,
        sortByName: "unitType.trnName",
        sortDirection: "asc",
        active: false,
        translationKey: "deviceType",
        columnId: COLUMN_DEVICE,
    },
    {
        heading: "Direction",
        accessor: "direction",
        isNumeric: false,
        id: 26,
        sortByName: "trDirection",
        sortDirection: "asc",
        active: false,
        translationKey: "direction",
        columnId: COLUMN_DIRECTION,
    },
    {
        heading: "Access Type",
        accessor: "access",
        isNumeric: false,
        id: 27,
        sortByName: "masterByTrMasterId.masterType.trnName",
        sortDirection: "asc",
        active: false,
        translationKey: "accessType",
        columnId: COLUMN_ACCESS,
    },
    {
        heading: "Date",
        accessor: "dateOnly",
        isNumeric: false,
        id: 28,
        searchOnName:"dateOnly",
        sortByName: "dateOnly",
        sortDirection: "asc",
        active: false,
        translationKey: "dateOnly",
        columnId: COLUMN_DATE,
        filterId:FILTER_DATE,
        settingDataName: "date",
        hideLookup: true
    },
]

export default TransactionColumn;
